import NewsTipCommentsSectionHeader from './NewsTipCommentsSectionHeader'

export default NewsTipCommentsSectionHeader
